import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";

import styles from "./SpeakerDistributionModal.module.scss";
import { messages } from "../Case1TechnicalPov.messages";
import * as appConfig from "appConfig";
import { PhotoView } from "@src/lms/jelly/extensions/layouts/photo-view/PhotoView";

const SLIDES_DATA = [
  {
    description: messages.modalSimulationDescription1,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case-example/technical-pov/simulation/1.png`,
  },
  {
    description: messages.modalSimulationDescription2,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case-example/technical-pov/simulation/2.png`,
  },
  {
    description: messages.modalSimulationDescription3,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case-example/technical-pov/simulation/3.png`,
  },
  {
    description: messages.modalSimulationDescription4,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case-example/technical-pov/simulation/4.png`,
  },
  {
    description: messages.modalSimulationDescription5,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case-example/technical-pov/simulation/5.png`,
  },
  {
    description: messages.modalSimulationDescription6,
    imgSrc: `${appConfig.STATIC_ASSETS_URL}/lms/case-example/technical-pov/simulation/6.png`,
  },
];

type SimulationsModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;
export const SimulationsModal: React.FC<SimulationsModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const slides = SLIDES_DATA.map((data, index) => {
    return (
      <div key={index} className={styles.slide}>
        <PhotoView imgSrc={data.imgSrc} description={formatMessage(data.description)} />
      </div>
    );
  });

  return (
    <CarouselModal {...props} title={formatMessage(messages.modalSimulationTitle)}>
      {slides}
    </CarouselModal>
  );
};

//TODO: override scrollbars colors
